export const iconFontAwesomeShoppingTruckFast = (
	<i className="fa-solid fa-truck-fast"></i>
);
